var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _circle, _rect, _circle2, _rect2, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _circle3, _circle4, _rect3, _path35, _path36, _rect4, _path37, _rect5, _rect6, _path38, _path39, _path40, _path41, _path42, _image;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgForbidden(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Forbidden",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 731.8 613.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#124c65;}.cls-2{fill:#1f84af;}.cls-3{fill:#196c8e;}.cls-4{fill:#e4f0f9;}.cls-5{fill:#94d9f2;}.cls-11,.cls-6{fill:#29abe2;}.cls-7{fill:#af5d5d;}.cls-8{fill:#babebf;}.cls-9{fill:#dd7a7a;}.cls-10{fill:#fff;}.cls-11{stroke:#545454;stroke-miterlimit:10;stroke-width:0.25px;}.cls-12{fill:#d4e7f4;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8122.93,687.28l-76.13,2.42q16-146.49,32-293l69.65,5.38Q8135.72,544.7,8122.93,687.28Z",
    transform: "translate(-7665.25 -78.98)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8122.93,687.28l-71.21,2.42,32.76-294.05,64,6.46Q8135.72,544.7,8122.93,687.28Z",
    transform: "translate(-7665.25 -78.98)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M8170.2,650.45l-312.12,4.26q-4.64-37.63-9.28-75.29h302.8Z",
    transform: "translate(-7665.25 -78.98)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M8175.65,653.32l-313.85,2q-4.65-37.65-9.29-75.29h302.8Z",
    transform: "translate(-7665.25 -78.98)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M7981.37,655l-25.19.16q-9.92-37.45-19.84-74.91h23Z",
    transform: "translate(-7665.25 -78.98)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M8035.08,654.36l-25.19.16q-9.93-37.46-19.84-74.91h23Q8024.05,617,8035.08,654.36Z",
    transform: "translate(-7665.25 -78.98)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M8089.67,654.36l-25.19.16q-9.91-37.46-19.84-74.91h23Q8078.65,617,8089.67,654.36Z",
    transform: "translate(-7665.25 -78.98)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M8138.71,654.36l-25.19.16-19.83-74.91h23Q8127.7,617,8138.71,654.36Z",
    transform: "translate(-7665.25 -78.98)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M7928.14,655l-25.19.16q-9.91-37.45-19.84-74.91h23Z",
    transform: "translate(-7665.25 -78.98)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7819.87,690.11l-76.13,2.42q16-146.47,32-293l69.66,5.38Z",
    transform: "translate(-7665.25 -78.98)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M7819.87,690.11l-71.21,2.42q16.38-147,32.77-294l64,6.46Z",
    transform: "translate(-7665.25 -78.98)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M8333.42,220.92a15.18,15.18,0,0,0,.34-3.18c0-8.67-7.28-15.7-16.25-15.7H8317a22.14,22.14,0,0,0-21.74-16.78,22.48,22.48,0,0,0-18,8.87,16.43,16.43,0,0,0-12.15-5.28c-9,0-16.25,7-16.25,15.7a14.9,14.9,0,0,0,.46,3.68c-.52,0-1.05-.06-1.58-.06-11.52,0-20.86,9-20.86,20.15,0,10.95,9,19.85,20.3,20.13A15.67,15.67,0,0,0,8254,250h55.1a15.72,15.72,0,0,0,7.82-2.08A16.63,16.63,0,0,0,8325,250a16,16,0,0,0,16.24-15.7A15.58,15.58,0,0,0,8333.42,220.92ZM8276,217.74h-2.15a13.69,13.69,0,0,0,1.53-1.09C8275.61,217,8275.82,217.39,8276,217.74Z",
    transform: "translate(-7665.25 -78.98)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M7842.13,138.15a24.9,24.9,0,0,0,.56-5.28c0-14.39-12.07-26.06-27-26.06-.31,0-.61,0-.92,0-3.71-16-18.44-27.86-36.06-27.86a37.35,37.35,0,0,0-29.91,14.72,27.3,27.3,0,0,0-20.16-8.76c-14.89,0-27,11.67-27,26.06a25.6,25.6,0,0,0,.75,6.1c-.86-.06-1.74-.1-2.62-.1-19.11,0-34.6,15-34.6,33.43,0,18.17,15,32.94,33.68,33.42a26,26,0,0,0,11.33,2.59h91.43a25.94,25.94,0,0,0,13-3.46,27.68,27.68,0,0,0,13.43,3.46c14.89,0,27-11.67,27-26.06A25.84,25.84,0,0,0,7842.13,138.15Zm-95.22-5.28h-3.58a28.64,28.64,0,0,0,2.55-1.81C7746.2,131.68,7746.54,132.28,7746.91,132.87Z",
    transform: "translate(-7665.25 -78.98)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M7914.09,676.77l-68.88,12.3L7779.6,398.49l64,6.46Q7878.85,540.87,7914.09,676.77Z",
    transform: "translate(-7665.25 -78.98)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M7924.07,691.37l-73-.08-66.48-292,59,5.71Z",
    transform: "translate(-7665.25 -78.98)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M8217.15,673.94l-68.88,12.29-65.61-290.58,64,6.46Q8181.91,538,8217.15,673.94Z",
    transform: "translate(-7665.25 -78.98)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M8227.12,688.54l-73-.08q-33.26-146-66.49-292l59,5.7Z",
    transform: "translate(-7665.25 -78.98)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M8206.8,540l-433.75,7-12.9-123.07H8181Q8193.88,482,8206.8,540Z",
    transform: "translate(-7665.25 -78.98)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M8214.38,544.7l-436.16,3.36q-6.45-61.54-12.91-123.07h420.8Q8200.24,484.84,8214.38,544.7Z",
    transform: "translate(-7665.25 -78.98)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M7944.39,547.48l-35,.27-27.57-122.46h31.94Q7929.07,486.39,7944.39,547.48Z",
    transform: "translate(-7665.25 -78.98)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M8019,546.4l-35,.27q-13.77-61.23-27.56-122.45h31.94Z",
    transform: "translate(-7665.25 -78.98)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M8094.89,546.4l-35,.27q-13.77-61.23-27.56-122.45h31.94Z",
    transform: "translate(-7665.25 -78.98)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M8163.05,546.4l-35,.27-27.57-122.45h31.95Z",
    transform: "translate(-7665.25 -78.98)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M7870.41,547.48l-35,.27q-13.78-61.23-27.56-122.46h31.94Z",
    transform: "translate(-7665.25 -78.98)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 652.16,
    cy: 384.44,
    r: 72.17
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 8313.06,
    y: 530.09,
    width: 20.38,
    height: 162.02,
    rx: 7.63,
    transform: "translate(-7658.21 -168.29) rotate(0.62)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 659.63,
    cy: 384.44,
    r: 72.17
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 8314.69,
    y: 408.76,
    width: 20.38,
    height: 109.31,
    rx: 7.63,
    transform: "translate(196.22 8709.31) rotate(-90)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M7976.57,286.13c7.36,19.81,25.22,58.19,61.24,70.51,17,5.83,41,6.82,42.42,2.11,1.21-3.87-12.51-12.3-12.39-12.45s6.09,6.46,14.7,7.83c6.62,1.06,14.14-1,14.77-4.15.23-1.15-1.85-3.4-6-7.84-6.66-7.13-7.45-7.94-7.25-8.22.61-.88,10.53,2.82,18.78,11,8.55,8.45,8.68,15.14,12.46,15.22,6.33.15,16.61-18.34,11.08-29.07-5.15-10-24.86-15-34.3-20-1.33-.71-2.64-1.44-2.65-1.44-2.16-1.19-4-2.25-6.09-3.47-30.63-17.74-33.67-26.43-49.1-29.95a58.61,58.61,0,0,0-26.38.34Z",
    transform: "translate(-7665.25 -78.98)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M8076.67,224.38a28.6,28.6,0,0,0-2.67-17,29.08,29.08,0,0,0-10.38-11.08c-9.6-6.46-30.08-13.22-48.45-2.77-21.7,12.35-25.77,40.34-20.12,56.38.07.21.14.39.18.52A77.33,77.33,0,0,0,7963,251.7c-12.62,3.27-21.22,9.09-27.15,13.27a468.87,468.87,0,0,0-50.69,41.64c-14.69,14-38.4,31.19-77.23,43.44l26.67,5.91c2.28-.73,5.56-1.77,9.53-2.89,20.41-5.79,33.32-10.16,45.86-8.45,17.91,2.45,20.58,11.59,43.83,16.73a105,105,0,0,0,27.3,2.34l3.31,51.22,3.53-.23.31,4.83,6.54-.42L7971.14,363l1.15-.14,1.16-.15c33.7-4.69,54.66-30.76,54.66-30.76,6.74-8.38,18.23-22.67,15.33-37.95-.9-4.73-2.79-14.68-10.5-21.18-2.19-1.85-5.37-4.56-5.08-5s5.09,3.4,12.53,5a32.3,32.3,0,0,0,10.08.32A36,36,0,0,0,8061.2,270c2.17-1,3.24-1.76,9.34-5.89,5.52-3.73,5.42-3.13,9-6,1.88-1.55,6-4.91,7.54-8.09C8090.2,243.64,8085.43,233.4,8076.67,224.38Z",
    transform: "translate(-7665.25 -78.98)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8028.15,237.68c-12.69,3.86-20.55,9.75-25.44,14.53-19.9,19.49-12.86,42.64-34.35,58.71-8.11,6.07-19.07,10.23-21.62,7.33-1.77-2,1.44-6.07-.43-8.78-4-5.77-24.92,3.3-25.39,2.09s19.88-10.12,19.49-11.18c-.49-1.33-32.89,12-35.29,7.41-2.27-4.3,23.32-22.67,22.94-23.19-.21-.29-7.93,5.33-19,13.61l5.44-15.27a101.43,101.43,0,0,1,40.34-28.41c6.79-2.56,11.18-4.36,17.64-4.78,10.12-.65,14,2.61,22.56.18,5.27-1.5,6-3.34,12.68-6.54A62.67,62.67,0,0,1,8028.15,237.68Z",
    transform: "translate(-7665.25 -78.98)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M7962.45,278.88c-2,18.84-8.18,47.06-28.67,61-6.52,4.43-19.6,10.88-22.57,7.6-1.83-2,1.56-6.11-.36-8.81-4.08-5.74-26,3.61-26.43,2.4s20.79-10.39,20.4-11.45c-.49-1.32-34.36,12.38-36.81,7.85-2.31-4.29,24.53-23,24.14-23.54-.22-.28-8.31,5.45-19.91,13.88l5.83-15.39a109,109,0,0,1,42.31-29,104.72,104.72,0,0,1,18.41-5Z",
    transform: "translate(-7665.25 -78.98)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M7961.87,284.67c-2,18.84-8.17,47.06-28.66,61-6.53,4.43-19.6,10.88-22.58,7.6-1.82-2,1.57-6.11-.35-8.81-4.08-5.74-26,3.6-26.44,2.4s20.8-10.39,20.4-11.45c-.49-1.33-34.36,12.38-36.8,7.84-2.31-4.29,24.52-23,24.13-23.53-.21-.28-8.3,5.44-19.91,13.88q2.92-7.69,5.83-15.39a108.94,108.94,0,0,1,42.31-29,104.67,104.67,0,0,1,18.42-5Z",
    transform: "translate(-7665.25 -78.98)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M7920.7,313.88c-4.88,16.48-16.42,41.68-44.75,56.93-9,4.85-26.8,12.49-30.26,10.16-1.9-1.29,1.87-4.7,1.08-6.84a2.24,2.24,0,0,0-.45-.66c-2.72-2.78-36.86,18.11-37.76,16.31-.3-.58,1.61-2.64,1.61-2.64,10.79-11.65,29.42-20.5,29.43-20.46s-40.05,17.07-43.79,8.42c-.77-1.79.24-4.15,1.19-6.38,7-16.48,28.15-13.18,28.08-13.45h0c-7-9.91-17,.05-29.74-5.15-7.71-3.15-16.18-11.81-16.26-16-.11-6,16.88.05,45.86-2.19a219.33,219.33,0,0,0,40.56-7.33c10.5-3,13.95-6.07,24.54-7.25Z",
    transform: "translate(-7665.25 -78.98)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M8002.17,289.11c14.8,12.7,36.82,3.2,41.55,13,3.92,8.11-6.52,22-9,21.43-1.47-.36.22-8.63-2.41-9.65-3.21-1.24-8.25,10.55-13.28,9.65s-5.43-13.75-9-13.84c-2.33-.06-3.06,5.51-7.6,12.31-5,7.5-12.77,13.72-14.82,12.39-3.58-2.3,11.89-26.3,5.33-32.37-2.53-2.34-7.26-1-9.23-.46-27.23,7.88-31,59.14-50,59.82-2,.08-5.22-1.1-11.68-3.45a100.35,100.35,0,0,1-20.19-10A44.49,44.49,0,0,1,7915,337.75c9.25-4.63,13.37-1.37,19.21-4.67,11-6.24,3.63-20.89,14.93-33.17,8.16-8.85,15.52-5.06,29-16.26a63.74,63.74,0,0,0,13.24-15.19C7992.47,274.1,7995,282.92,8002.17,289.11Z",
    transform: "translate(-7665.25 -78.98)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M8088,245.5a41.36,41.36,0,0,1-8.95-6.26c-11.43-10.54-8.37-21.26-19-27.83-6.16-3.82-11.21-3.35-13.59-8.41-1.91-4.06-1.38-10.15,2.11-12.45s9.16,1.25,13.39,3.91a32.21,32.21,0,0,1,8.38,7.62c1.63,2.1,3,4.37,5.89,11.66,3.32,8.29,4.47,12.6,7.41,20.65C8085.49,239.31,8087.07,243.2,8088,245.5Z",
    transform: "translate(-7665.25 -78.98)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M7988.6,250.84c3.63,4-.06,14.61-5.17,21.94-13.22,19-36.87,17.13-41.28,31.86-2.5,8.34-3.46,12.46-3.46,12.46-1.86,7.93-1.77,10.34-3.81,11.42-3.82,2-11.7-2.38-12.46-7.26-.58-3.77,3.14-7.26,3.12-7.27a12.41,12.41,0,0,0-3.12,7.27c-.19,3,1,4.41.35,4.84-1.26.89-8.11-3.74-8-8.65.11-3.87,4.53-6.6,4.52-6.6s-3.92,2.46-4.52,6.6c-.5,3.43,1.68,5.17.69,6.58-1.3,1.83-6.69,1.14-10.28-1.51-4.06-3-6.69-9-4.56-12.86.62-1.11,1.9-2.17,4.43-4.23a75.36,75.36,0,0,1,8.31-6.09c.2.21-12.21,11.77-15.95,9.91-2-1-.91-5.37.17-9.35,5.18-19.2,6.85-29,14.18-36.23,6.68-6.57,14.39-9.41,22.62-12.44a57.26,57.26,0,0,1,13.38-3.69c10.63-1.4,13.07,1.84,28.16,2.13C7984.38,249.84,7986.79,248.82,7988.6,250.84Z",
    transform: "translate(-7665.25 -78.98)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M8060.52,236.4c8.72,13.66,23.39,17,22.78,18.38-.44,1-7.47-1.39-31.81-10.17-17.35-6.26-20.9-7.6-21.35-10.68-1-6.77,13.2-17.12,21.35-14C8056.37,221.86,8055,227.8,8060.52,236.4Z",
    transform: "translate(-7665.25 -78.98)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 373.79,
    cy: 154.37,
    r: 7.72
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 376.57,
    cy: 151.81,
    r: 2.56
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 357.16,
    y: 136.41,
    width: 33.27,
    height: 7.99,
    rx: 1.74
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M8106.19,276.61",
    transform: "translate(-7665.25 -78.98)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M8184.63,271.07q-37.64-5.22-77.25-9.69-15.49-1.72-30.74-3.28a24,24,0,0,0,5.07-3.32,17.12,17.12,0,0,0,6.13-11.41c8.39,3.78,17.69,7.54,27.92,11.09A372.32,372.32,0,0,0,8184.63,271.07Z",
    transform: "translate(-7665.25 -78.98)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 7967.29,
    y: 420.3,
    width: 29.32,
    height: 7.11,
    rx: 3.23,
    transform: "translate(-5027.67 -5598.92) rotate(45)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M8119.69,358.29",
    transform: "translate(-7665.25 -78.98)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 7956.77,
    y: 420.3,
    width: 21.59,
    height: 7.11,
    rx: 3.23,
    transform: "translate(1977.82 -7456.04) rotate(99.08)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 7971.15,
    y: 410.46,
    width: 21.59,
    height: 7.11,
    rx: 3.23,
    transform: "translate(-7425.16 -1651.52) rotate(11.42)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M7998.43,312.84",
    transform: "translate(-7665.25 -78.98)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8069.1,197.21l-75.46,24.35.87-10.64a206.06,206.06,0,0,1,31.69-17.66,215.38,215.38,0,0,1,38.27-13Z",
    transform: "translate(-7665.25 -78.98)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M8071.92,179.43a147.43,147.43,0,0,0-75.49,34.67,18,18,0,0,1-13.49-4.65,19,19,0,0,1-5.81-11.77,38.38,38.38,0,0,0,16.95-10.35,39.33,39.33,0,0,0,7.83-12.2,29.71,29.71,0,0,0,18.77.21c13.89-4.64,18.56-18.51,19.12-20.26a49.84,49.84,0,0,0,18.33,12.49c8.45,3.2,16.44,3.23,17.14,6.64C8075.66,176.07,8073.66,178.05,8071.92,179.43Z",
    transform: "translate(-7665.25 -78.98)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M8054.15,195a37.3,37.3,0,0,1-15.71-10.12,30.59,30.59,0,0,1-6.73-11.65,20.68,20.68,0,0,0,5.89-4.06,19,19,0,0,0,4.32-6.48,77.14,77.14,0,0,0,8.43,3.82,74.26,74.26,0,0,0,8.65,2.7,23.43,23.43,0,0,1,2.68,13.75A17.53,17.53,0,0,1,8054.15,195Z",
    transform: "translate(-7665.25 -78.98)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8010.54,320.14a32.07,32.07,0,0,1-14.95-9.64,28.55,28.55,0,0,1-6.06-11.66,23.06,23.06,0,0,0,6-4.46,22.36,22.36,0,0,0,4.56-6.87,66.09,66.09,0,0,0,8.11,3.51,63.74,63.74,0,0,0,8.37,2.36,23.72,23.72,0,0,1,2,14A20.52,20.52,0,0,1,8010.54,320.14Z",
    transform: "translate(-7665.25 -78.98)"
  })), _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 401,
    height: 182,
    transform: "matrix(0.06, -0.02, 0.02, 0.07, 368.79, 95.05)",
    xlinkHref: "../../../../Users/HP/Downloads/logo%20nubeteck%20azul%20recorte.png"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForbidden);
export default __webpack_public_path__ + "static/media/Forbidden.990ccaa854c02c5f6f337c13bcf3a93d.svg";
export { ForwardRef as ReactComponent };